export const selectMarkPosition = (state) => state.eventMarkPosition;
